<template>
      <div class="upload_k">
            <div class="upload_block">
                
                  <div id="Loading" v-html="videomsg">
                  
                  </div>
                  <input v-bind:id="inputname"  type="file" class="upload_input" v-on:change="uploadfile" >
            </div>
      </div>
</template>

<script>

      export default {
            props:['uploadType','functionstr','type','src'],  //接受父组建传递的值
            data() {
                  return {
                        videomsg:'+',
                        inputname:this.uploadType+Math.ceil(Math.random()*100),
                  }
            },
            mounted() {
                 
                  if(this.type=='video' && this.src){
                        this.videomsg='+';
                  }else if(this.type=='img' && this.src){
                        this.videomsg='<img src="'+this.src+'" width="100" height="100">';
                  }else if(this.type=='audio' && this.src){
                        this.videomsg='+';
                  }
                  console.log(this.inputname);
            },
            methods: {
                  uploadfile:function () {
                        let x = document.getElementById(this.inputname).files[0];
                        let params = new FormData() ; //创建一个form对象
                        params.append(this.inputname,x,x.name);  //append 向form表单添加数据
                        this.videomsg='<div class="loader-inner ball-beat"><div></div> <div></div> <div></div></div>';
                        //console.log('start uploading');
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/'+this.uploadType,
                              data:params,
                              //async:true,
                              headers:{
                                    'Content-Type':'multipart/form-data',
                                    apitoken:localStorage.getItem('apitoken'),
                                    ffname:this.inputname
                              }
                        }).then(function OnSuccess(response) {
                              //console.log('ready uploading')
                              
                              if(response.status==200){
                                    
                                    if(response.data.code==1){
                                          //lose
                                          alert(response.data.msg);
                                          this.videomsg='+'
                                    }else if(response.data.code==0){
                                          //success
                                          if(this.type=='video'){
                                                this.videomsg='视频上传成功';
                                          }else if(this.type=='img'){
                                                this.videomsg='<img src="'+response.data.url+'" width="100" height="100">';
                                          }else if(this.type=='audio'){
                                                this.videomsg='音频上传成功';
                                          }
                                          
                                          alert(response.data.msg);
                                          this.$emit(this.functionstr,response.data.url);
                                          
                                    }
                                    
                                    //console.log('uploading ok')
                                    
                                    
                              }else{
                                    console.log('uploading...')
                              }

                        }.bind(this)).catch(function OnError(response) {
                              console.log('传输异常')
                              console.log(response)
                        })
                        
                        
                  }


            }


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .upload_k{
            width:100%;
            height:120px;
      }
      .upload_block{
            width:100px;
            height:100px;
            border: 1px dashed #d9d9d9;
            margin-right: 3px;
            text-align: center;
            line-height:100px;
            overflow:hidden;
            
      }
      .upload_input{
            width:100px;
            height:100px;
            opacity: 0;
            top:-100px;
            position: relative;
            z-index:199;
      }





      #Loading {
            top:50%;
            left:50%;
            position: relative;
            -webkit-transform: translateY(-50%) translateX(-50%);
            transform: translateY(-50%) translateX(-50%);
            z-index:1;
      }
      @-webkit-keyframes ball-beat {
            50% {
                  opacity: 0.2;
                  -webkit-transform: scale(0.75);
                  transform: scale(0.75); }
      
            100% {
                  opacity: 1;
                  -webkit-transform: scale(1);
                  transform: scale(1); } }

      @keyframes ball-beat {
            50% {
                  opacity: 0.2;
                  -webkit-transform: scale(0.75);
                  transform: scale(0.75); }
      
            100% {
                  opacity: 1;
                  -webkit-transform: scale(1);
                  transform: scale(1); } }

      .ball-beat > div {
            background-color: #279fcf;
            width: 15px;
            height: 15px;
            border-radius: 100% !important;
            margin: 2px;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
            display: inline-block;
            -webkit-animation: ball-beat 0.7s 0s infinite linear;
            animation: ball-beat 0.7s 0s infinite linear; }
      .ball-beat > div:nth-child(2n-1) {
            -webkit-animation-delay: 0.35s !important;
            animation-delay: 0.35s !important; }

</style>



// WEBPACK FOOTER //
// src/components/UploadFile.vue